module.exports = __webpack_public_path__ + "1555904a3ed0f25d93fafb91d409d99e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/6.jpg
// module id = 231
// module chunks = 0